module.exports = __webpack_public_path__ + "img/bg_judicial_02.a282ece0.jpg";